import { render, staticRenderFns } from "./MakeCricketPredictions.vue?vue&type=template&id=b02e9702&scoped=true&"
import script from "./MakeCricketPredictions.vue?vue&type=script&lang=js&"
export * from "./MakeCricketPredictions.vue?vue&type=script&lang=js&"
import style0 from "./MakeCricketPredictions.vue?vue&type=style&index=0&id=b02e9702&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02e9702",
  null
  
)

export default component.exports